import React, { useCallback, useEffect, useState, useRef } from "react";
import styles from "./index.module.css";
import Navbar from "../../components/molecules/Navbar";
import Footer from "../../components/molecules/Footer";
import Button from "../../components/atoms/Button";
import { useNavigate, useLocation } from "react-router-dom";
// import { process.env.REACT_APP_DASHBOARD_URL } from "../../utils/keys";
import { ApplicantStage } from "../../utils/applicationStage";
import { fraudCheckInsurfin } from "../../services/riskEngine";

function PFCollection() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState<{
    id?: number;
    applicationId?: string;
    fundCode?: string;
    productId?: string;
    loanAmount?: number;
    emi?: number;
    emiFirstDate?: string;
    dayOfEmi?: number;
    sanctionLetterUrl?: string;
    productDetails?: any;
  }>({});
  const [showRefreshNotice, setShowRefreshNotice] = useState(true);
const data = sessionStorage.getItem("data")
    let [userData, setUserData] = useState<{
      application:string,
      dob:string,
      applicationId: string;
      userId: string;
      email: string;
      panId: string;
      dateOfBirth: string;
      instituteId: string;
      firstName: string;
      lastName: string;
      mobile: string;
      course: string;
      fees: number;
      studentName: string;
      instituteName: string;
      redirectUrl: string;
      channelId: number;
      flow:string;
    }>({
      application:'',
      applicationId: "",
      userId: "",
      instituteId: "",
      firstName: "",
      lastName: "",
      panId: "",
      dateOfBirth: "",
      dob:'',
      email: "",
      mobile: "",
      course: "",
      fees: 0,
      studentName: "",
      instituteName: "",
      redirectUrl: "",
      channelId: 0,
      flow:''
    });
  const stageFetchRef = useRef(false);
  const productsFetchRef = useRef(false);

  useEffect(() => {
    if (!data) return;
    try {
      const jsonData = atob(data);
      const parsedUserData = JSON.parse(jsonData);
      setUserData(parsedUserData);

      // Fetch stage only once
      if (!stageFetchRef.current) {
        stageFetchRef.current = true;
        const applicationId =
          parsedUserData?.applicationId ||
          (location?.state?.data?.existing
            ? location?.state?.data?.applicationId
            : location?.state?.data?.application);

        if (!applicationId) {
          console.error("No valid applicationId found");
        } else {
          setLoading(true);
          fetch(
            `${process.env.REACT_APP_DASHBOARD_URL}/admin/application/stage?applicationId=${applicationId}`
          )
            .then((res) => {
              if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
              return res.json();
            })
            .then((res) => {
              setLoading(false);
              console.log(res.data, "bank upload");
              if (res?.data?.stage) {
                switch (res?.data?.stage) {
                  case ApplicantStage.PanVerification:
                    navigate("/enter-pan", { state: { data: location?.state?.data } });
                    break;
                  case ApplicantStage.AddressDetails:
                    navigate("/work-details", { state: { data: location?.state?.data } });
                    break;
                  case ApplicantStage.BankStatement:
                    navigate("/view-offers", { state: { data: location?.state?.data } });
                    break;
                  case ApplicantStage.AwaitingApproval:
                  case ApplicantStage.CoapplicantRequired:
                  case ApplicantStage.AwaitingCoapplicantConsent:
                    navigate("/parking-page", { state: { data: location?.state?.data } });
                    break;
                  case ApplicantStage.Approved:
                    navigate("/select-emi", { state: { data: location?.state?.data } });
                    break;
                  case ApplicantStage.SanctionTermsAccepted:
                  case ApplicantStage.Digilocker:
                  case ApplicantStage.Selfie:
                  case ApplicantStage.Agreement:
                  case ApplicantStage.BankAccountVerified:
                    navigate("/sanctions", { state: { data: location?.state?.data } });
                    break;
                  case ApplicantStage.Mandate:
                  case ApplicantStage.PFCollections:
                    navigate("/pf-collection", { state: { data: location?.state?.data } });
                    break;
                  case ApplicantStage.ProcessComplete:
                  case ApplicantStage.Disbursed:
                    navigate("/disbursed-page", { state: { data: location?.state?.data } });
                    break;
                  case ApplicantStage.Rejected:
                    navigate("/rejected-page", { state: { data: location?.state?.data } });
                    break;
                  default:
                    try {
                      navigate(`/${atob(JSON.stringify(location?.state?.data))}`);
                    } catch (err) {
                      navigate(`/pan-details/:data`);
                    }
                    break;
                }
              }
            })
            .catch((err) => {
              console.error("API call failed:", err);
              setLoading(false);
            });
        }
      }
    } catch (error) {
      console.error("Error parsing session data:", error);
      setLoading(false);
    }
  }, []);
  // defer products fetch until we have userData.applicationId
  useEffect(() => {
    if (userData?.applicationId && !productsFetchRef.current) {
      productsFetchRef.current = true;
      getProductsDetails();
    }
  }, [userData?.applicationId]);

  const [status, setStatus] = useState(null);

  const getDetails = useCallback(async () => {
  try {
    if (stageFetchRef.current) return;
    stageFetchRef.current = true;
    const userId = userData?.userId || location?.state?.data?.userId;
    const applicationId = userData?.applicationId || 
      (location?.state?.data?.existing ? 
        location?.state?.data?.applicationId : 
        location?.state?.data?.application);

    if (!userId || !applicationId) {
      console.error('Missing required data:', { userId, applicationId });
      return;
    }
    setLoading(true);
    const stageResponse = await fetch(
      `${process.env.REACT_APP_DASHBOARD_URL}/admin/application/stage?applicationId=${applicationId}`
    );

    if (!stageResponse.ok) throw new Error(`Stage failed: ${stageResponse.status}`);
    
    const stageResult = await stageResponse.json();
    console.log('Stage result:', stageResult);
    
  } catch (error) {
    console.error('Error:', error);
  } finally {
    setLoading(false);
  }
}, [userData?.userId, userData?.applicationId, location?.state?.data]);

useEffect(() => {
  getDetails();
}, [getDetails]);
  useEffect(() => {
    if (status === ApplicantStage.Disbursed) {
      navigate("/disbursed-page", {
        state: { data: location?.state?.data },
      });
    }
  }, [status, location?.state?.data, navigate]);

  // useEffect(() => {
  //   async function fetchData() {
  //     const response1 = await fetch(
  //       `${process.env.REACT_APP_DASHBOARD_URL}/login/auth`,
  //       {
  //         method: "POST",
  //         body: JSON.stringify({
  //           memberId: "26ae9a50-b0cd-4e7a-abc4-705edd5ae399",
  //         }),
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     const result1 = await response1.json();
  //     const authToken = result1.data;

  //     const fraudCheckResult = await fraudCheckInsurfin(
  //       authToken,
  //       JSON.stringify({
  //         applicationId: location?.state?.data?.application,
  //         userId: location?.state?.data?.userId,
  //       })
  //     );

  //     console.log(fraudCheckResult);
  //   }
  //   fetchData();
  // }, [location?.state?.data?.application, location?.state?.data?.userId]);

  const getProductsDetails = async () => {
    try {
      const applicationId =
        userData?.applicationId ||
        (location?.state?.data?.existing
          ? location?.state?.data?.applicationId
          : location?.state?.data?.application);

      if (!applicationId) {
        console.warn("getProductsDetails: missing applicationId, skipping fetch");
        return;
      }

      const response = await fetch(
        `${process.env.REACT_APP_DASHBOARD_URL}/admin/application/sanction-details?applicationId=${applicationId}`
      );
      const result = await response.json();
      console.log(result);
      setProduct(result.data);

      const response1 = await fetch(`${process.env.REACT_APP_DASHBOARD_URL}/login/auth`, {
        method: "POST",
        body: JSON.stringify({
          memberId:
            userData?.channelId === 12
              ? "7b75d903-dabf-4571-9052-61c825403004"
              : "26ae9a50-b0cd-4e7a-abc4-705edd5ae399",
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result1 = await response1.json();
      const authToken = result1.data;

      const response2 = await fetch(
        `${process.env.REACT_APP_DASHBOARD_URL}/products/id?productId=${result.data.productId}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const result2 = await response2.json();
      console.log(result2);

      setProduct((prev) => ({
        ...prev,
        productDetails: result2.data,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const paymentLink = () => {
    fetch(`${process.env.REACT_APP_DASHBOARD_URL}/login/auth`, {
      method: "POST",
      body: JSON.stringify({
        // memberId: location?.state?.data.userId,
       memberId:
            userData?.channelId === 12
              ? "7b75d903-dabf-4571-9052-61c825403004"
              : "26ae9a50-b0cd-4e7a-abc4-705edd5ae399",
      }),
      headers: {
        "Content-Type": "application/json",
      },
    }).then((res) => {
      res.json().then((data) => {
        console.log(data);
        if (data.message === "Successful") {
          fetch(
            `${process.env.REACT_APP_DASHBOARD_URL}/pre-disbursement-collection/create-link-for-user`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${data.data}`,
              },
              body: JSON.stringify({
                userId: userData?.userId || location?.state?.data?.userId || "a34c5d28-f8bf-432a-9d65-fe941e68c433",
                applicationId: userData?.applicationId || location?.state?.data?.application || "FM24000923",
                advEmi:
                  Number(product?.productDetails?.advanceEmis) *
                  Number(product?.emi),
                processingFee:
                  Number(product?.productDetails?.processingfeeValue) *
                    Number(product?.loanAmount) +
                  0.18 *
                    Number(product?.loanAmount) *
                    Number(product?.productDetails?.processingfeeValue),
                totalAmount: Math.ceil(
                  Number(product?.productDetails?.processingfeeValue) *
                    Number(product?.loanAmount) +
                    0.18 *
                      Number(product?.loanAmount) *
                      Number(product?.productDetails?.processingfeeValue) +
                    Number(product?.productDetails?.advanceEmis) *
                      Number(product?.emi)
                ),
                instituteName: '1a62ed6b-a5f5-4ab3-acfa-6e353b070149',
                status: 0,
                utr: "string",
                mode: 0,
                paidDate: {},
                remarks: "string",
              }),
            }
          )
            .then((res) => res.json())
            .then((data) => {
              console.log(data);
              window.open(data.data, "_blank", "noopener,noreferrer");
              setShowRefreshNotice(true);
            });
        }
      });
    });
  };

  return (
    <div className={styles.body}>
      <div className={styles.backdrop}>
        <Navbar />
        <div className={styles.container}>
          {showRefreshNotice && (
            <div
              style={{
                background: "#fff4cc",
                border: "1px solid #f0c36a",
                padding: "10px 12px",
                borderRadius: 8,
                marginBottom: 12,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ fontSize: 14, color: "#333" }}>
                After completing the payment,
                please refresh this page to update the payment  .
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <button
                  onClick={() => window.location.reload()}
                  style={{
                    background: "#D32028",
                    color: "#fff",
                    border: "none",
                    padding: "4px 6px",
                    borderRadius: 6,
                    cursor: "pointer",
                  }}
                >
                  Refresh
                </button>
                
              </div>
            </div>
          )}
          <br />
          <p
            style={{
              fontSize: "18px",
              textAlign: "center",
            }}
          >
            Your Mandate process is complete, disbursement will be done after
            the payment of Rs.{" "}
            <strong
              style={{
                fontFamily: "Outfit",
              }}
            >
              {Math.ceil(
                Number(product?.productDetails?.processingfeeValue) *
                  Number(product?.loanAmount) +
                  0.18 *
                    Number(product?.loanAmount) *
                    Number(product?.productDetails?.processingfeeValue) +
                  Number(product?.productDetails?.advanceEmis) *
                    Number(product?.emi)
              )}{" "}
            </strong>
            as Processing Fee / Advance EMI.
          </p>
          <div style={{ display: "flex" }}>
            <div>
              <p>Processing Fee</p>
              <p>GST On PF(18%)</p>
              <p>No. of Advance EMIs</p>
              <p>Advance EMI Amount</p>
            </div>
            <div style={{ marginLeft: "1.5em" }}>
              <p>:</p>
              <p>:</p>
              <p>:</p>
              <p>:</p>
            </div>
            <div style={{ marginLeft: "1.5em" }}>
              <p>
                Rs.{" "}
                {Number(product?.productDetails?.processingfeeValue) *
                  Number(product?.loanAmount)}
              </p>
              <p>
                Rs.{" "}
                {Math.ceil(
                  0.18 *
                    Number(product?.loanAmount) *
                    Number(product?.productDetails?.processingfeeValue)
                )}
              </p>
              <p>{Number(product?.productDetails?.advanceEmis)}</p>
              <p>
                Rs.{" "}
                {Number(product?.productDetails?.advanceEmis) *
                  Number(product?.emi)}
              </p>
            </div>
          </div>
                <br/>
          {/* <p >Processing Fee : Rs.{" "} {Number(product?.productDetails?.processingfeeValue)*Number(product?.loanAmount)}</p>
          <p>Processing Fee GST(18%) : Rs.{" "} {(
                0.18 * Number(product?.loanAmount)*Number(product?.productDetails?.processingfeeValue))}</p>
          <p>No. of Advance EMIs : {Number(product?.productDetails?.advanceEmis)}</p>
          <p>Advance EMI Amount : Rs.{" "} {( Number(product?.productDetails?.advanceEmis) *
                Number(product?.emi))}</p> */}
          <Button
            insureFin={location?.state?.data?.channelId === 5}
            text={"Pay Now"}
            onPress={() => paymentLink()}
          />
          <br/>
          <button onClick={()=> navigate('/disbursed-page', {state:{data:location?.state?.data}})}> Skip (for dev purpose) </button>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default PFCollection;
